import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const checkboxInputV2Migration: PropsMigration = {
  mode: 'props',
  description:
    'Migrate Checkbox Input element to v2 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'checkboxInput'>): void => {
    const checkboxInputProps = props;

    if (
      checkboxInputProps?.style?.general?.title &&
      !checkboxInputProps?.content?.title?.iconColor
    ) {
      const currentColor = checkboxInputProps.style.general.title.color1;
      checkboxInputProps.content = {
        ...checkboxInputProps.content,
        title: {
          ...checkboxInputProps.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
